jQuery(document).ready(function($) {
    var $carousel = $('.custom-carousel');
    if (!$carousel.length) return;

    var $track = $carousel.find('.carousel-track');
    var $items = $carousel.find('.carousel-item');
    var $nextBtn = $carousel.find('.carousel-btn.next');
    var $prevBtn = $carousel.find('.carousel-btn.prev');

    var index = 0;
    var visibleItems = 3;
    var total = $items.length;

    function updateCarousel() {
        var width = $items.outerWidth(true); // include margin
        $track.css('transform', 'translateX(' + (-index * width) + 'px)');
    }

    $nextBtn.on('click', function() {
        if (index < total - visibleItems) {
            index++;
            updateCarousel();
        }
    });

    $prevBtn.on('click', function() {
        if (index > 0) {
            index--;
            updateCarousel();
        }
    });

    $(window).on('resize', updateCarousel);

});


$(document).on('click', '.collaps-title', function() {
	 $(this).parent().toggleClass('act');

});
